var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.25 4.08331L29.1725 16.8641L42.4167 18.9262L32.8333 28.8691L35.095 42.9158L23.25 36.2804L11.405 42.9158L13.6667 28.8691L4.08334 18.9262L17.3275 16.8641L23.25 4.08331Z",
    stroke: "#0E1E2F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiStar);
export default __webpack_public_path__ + "static/media/fi_star.a8b295e8c92c608d5898ba1af669decd.svg";
export { ForwardRef as ReactComponent };